import { debugFactory } from '@iva/debugger';
// debugger
const config = {
    name: 'IdentityStorage',
    fColor: 'white',
    bColor: '#ccc',
};
const debug = debugFactory(config);
// logger
let dotInstance = null;
const initDot = () => {
    if (window.DOT) {
        dotInstance = window.DOT.getNewInstance();
        dotInstance.cfg({ service: 'idt', mousedown: false, load: false, impress: false });
    }
};
const dotLog = (data) => {
    if (!dotInstance) {
        initDot();
    }
    dotInstance === null || dotInstance === void 0 ? void 0 : dotInstance.hit('event', data);
};
const sendToConfessor = (msg, msgType = 'error', stack) => {
    var _a;
    const data = Object.assign({ msg,
        msgType, href: window.location.href, referrer: document.referrer }, (stack && { stack }));
    (_a = navigator.sendBeacon) === null || _a === void 0 ? void 0 : _a.call(navigator, `https://confessor.iva.seznam.cz/identity-storage`, new URLSearchParams(data));
};
export { debug, dotLog, sendToConfessor };
